<template>
  <a-modal
    :title="title"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="第三方">
          <span>{{ thirdNameOf(model.thirdParty || defaultThirdParty) }}</span>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="动作">
          <a-select
            placeholder="请选择动作"
            v-decorator="[ 'action', validatorRules.action]">
            <a-select-option v-for="item in actionList" :value="item.itemValue" :key="item.itemValue">{{ item.itemText }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="地址">
          <a-input placeholder="请输入地址" :maxLength="256" v-decorator="[ 'url', validatorRules.url]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="状态">
          <a-select v-decorator="[ 'status', validatorRules.status]">
            <a-select-option :value="1">正常</a-select-option>
            <a-select-option :value="2">冻结</a-select-option>
          </a-select>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import { addThirdAction, editThirdAction, getThirdAll } from '@/webpublicapi/third'
import { getDictList } from '@/webpublicapi/dict'

export default {
  name: 'ThirdActionModal',
  data () {
    return {
      title: '操作',
      visible: false,
      model: {},
      // 父页面第三方行操作栏传入：新增动作的归属第三方，锁定不可改
      defaultThirdParty: '',
      // 第三方列表，用于编码映射显示名
      thirdList: [],
      actionList: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        action: { rules: [{ required: true, message: '请选择动作!' }] },
        url: { rules: [{ required: true, message: '请输入地址!' }] },
        status: { rules: [{ required: true, message: '请选择状态!' }], initialValue: 1 }
      }
    }
  },
  created () {
    this.loadThirdList()
    this.loadActionList()
  },
  methods: {
    loadThirdList () {
      getThirdAll().then(res => {
        if (res.code === 1000) {
          this.thirdList = res.data
        }
      })
    },
    // 第三方编码映射显示名，无匹配或未配名字时回退编码
    thirdNameOf (thirdParty) {
      const third = this.thirdList.find(item => item.thirdParty === thirdParty)
      return (third && third.thirdName) || thirdParty
    },
    loadActionList () {
      getDictList().then(res => {
        if (res.code === 1000 && res.data.third_action) {
          this.actionList = res.data.third_action
        }
      })
    },
    add () {
      this.edit({})
    },
    edit (record) {
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'action', 'url', 'status'))
      })
    },
    // 确定
    handleOk () {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          values.url = (values.url || '').trim()
          const formData = Object.assign(this.model, values)
          // 归属第三方锁定：新增取父页面传入的当前行，编辑保持原值
          if (!formData.thirdParty) {
            formData.thirdParty = this.defaultThirdParty
          }
          let obj
          if (!this.model.id) {
            obj = addThirdAction(formData)
          } else {
            obj = editThirdAction(formData)
          }
          obj.then((res) => {
            if (res.code === 1000) {
              that.$message.success(res.msg)
              that.$emit('ok')
            } else {
              that.$message.warning(res.msg)
            }
          }).finally(() => {
            that.confirmLoading = false
            that.close()
          })
        }
      })
    },
    // 关闭
    handleCancel () {
      this.close()
    },
    close () {
      this.$emit('close')
      this.visible = false
    }
  }
}
</script>
